var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStembureauInside(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 320.99 569.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#958e88;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17{stroke-width:0px;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#d7c0b5;}.cls-4{fill:#e17468;}.cls-5{fill:#a9291c;}.cls-6{fill:#ebf4f7;}.cls-7{fill:#d26e60;}.cls-8{fill:#c7c7c7;}.cls-9{fill:#fff;}.cls-10{fill:#f4ddcc;}.cls-11{fill:#bc7b6d;}.cls-12{fill:url(#linear-gradient-2);}.cls-13{fill:#e0d8d3;}.cls-14{fill:url(#linear-gradient-3);}.cls-15{fill:#e5d0c4;}.cls-16{fill:#dbdbdb;}.cls-17{fill:#ebebeb;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 233.88,
    y1: 104.16,
    x2: 233.88,
    y2: -0.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbdbdb",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 171.72,
    y1: 93.61,
    x2: 171.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 112.09,
    y1: 82.59,
    x2: 112.09,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "84.48 30.47 92.74 30.43 92.75 20.2 75.67 20.11 66.88 20.03 58.32 19.92 58.03 30.86 75.73 30.59 84.48 30.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "87.02 213.36 78.23 213.45 61.15 213.53 61.16 223.76 69.42 223.8 78.17 223.92 95.87 224.2 95.58 213.25 87.02 213.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "49.3 128.82 40.51 128.9 23.43 128.99 23.44 139.22 31.7 139.26 40.45 139.37 58.15 139.65 57.85 128.7 49.3 128.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "233.28 57.39 231.86 57.37 223.3 57.26 223.01 68.21 233.28 68.05 233.28 57.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m294.73,383.67v145.5h-8.86v-145.5H109.35v145.5h-8.86V148.17h220.39l.11-147.93-86.51-.06v56.49l6.13-.05,17.58-.06h.5s0,.5,0,.5v11.19s0,.46,0,.46h-.46s-8.87-.06-8.87-.06l-8.83-.13-6.04-.11v30.4h2.73v3.71h2.39l4.94,19.92,6.06,10.73h-11.62c-.02,2.82-2.3,5.1-5.13,5.11-2.83,0-5.13-2.28-5.15-5.11h-11.53l6.05-10.73,4.94-19.92h2.38v-3.71h2.74v-30.42l-10.27-.18-.22-11.19v-.23h.24s8.79-.1,8.79-.1h1.46V.17l-60.96-.05v88.13h2.73v3.71h2.39l4.94,19.92,6.06,10.73h-11.58c0,2.84-2.29,5.14-5.13,5.15s-5.14-2.29-5.15-5.13c0,0,0-.01,0-.02h-11.57l6.05-10.73,4.94-19.92h2.38v-3.71h2.74V.13l-58.43-.04v77.15h2.74v3.71h2.39l4.94,19.92,6.05,10.73h-11.58c0,2.84-2.3,5.14-5.14,5.14s-5.14-2.3-5.14-5.14h-11.57l6.06-10.73,4.94-19.92h2.38v-3.71h2.73V.08L.42,0l-.42,569,320.56.24.14-185.57h-25.98Zm-52.1-301.32l-.23-11.19v-.23h.25s8.79-.1,8.79-.1l8.79-.07,17.57-.06h.51s0,.5,0,.5v11.19s0,.46,0,.46h-.46s-8.86-.06-8.86-.06l-8.84-.13-17.51-.31ZM109.34,46.41l-35.16-.03v-11.19s35.17.03,35.17.03v11.19Zm-51.53-26.97h.24s8.79-.1,8.79-.1l8.79-.07,17.58-.06h.5v11.69s0,.46,0,.46h-.46s-8.87-.06-8.87-.06l-8.83-.13-17.51-.31-.22-11.19v-.23ZM22.97,128l17.58.06,8.79.07,8.79.1h.24s0,.23,0,.23l-.22,11.19-17.51.31-8.83.13-8.87.06h-.46s0-.46,0-.46v-11.19s0-.5,0-.5h.5Zm56.75,100.53v11.19s-35.15.03-35.15.03v-11.19s35.15-.03,35.15-.03Zm5.87,113.91v186.84H23.92s-12.57,0-12.57,0v-184.07l27.43-53.77h0l8.39-16.44h3.16l.25.47c.31.59.9,1.72,1.7,3.26l2.08,3.97c.24.46.49.94.75,1.43l.63,1.21c.14.26.27.52.41.79l1.42,2.72s.01.02.02.03l27.82,53.21.18.04v.32Zm10.28-118.24l-17.51.31-8.83.13-8.87.06h-.46s0-.46,0-.46v-11.19s0-.5,0-.5h.5s17.58.06,17.58.06l8.79.07,8.79.1h.24v.23s-.22,11.19-.22,11.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "240.71 67.93 249.46 67.82 257.72 67.77 257.73 57.54 240.65 57.46 234.48 57.4 234.48 68.03 240.71 67.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "269.06 81.96 277.32 81.97 277.28 71.73 260.21 71.65 251.42 71.57 242.85 71.45 242.62 82.35 260.32 82.07 269.06 81.96"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 74.18,
    y: 35.21,
    width: 35.16,
    height: 11.19
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "240.65 57.46 257.73 57.54 257.72 67.77 249.46 67.82 240.71 67.93 234.48 68.03 234.48 68.41 240.52 68.52 249.35 68.65 258.22 68.7 258.68 68.7 258.68 68.24 258.69 57.05 258.69 56.55 258.19 56.55 240.61 56.61 234.48 56.66 234.48 57.4 240.65 57.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "231.86 57.37 233.28 57.39 233.28 56.67 231.82 56.68 223.03 56.79 222.79 56.79 222.79 57.02 223.01 68.21 223.3 57.26 231.86 57.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "223.01 68.21 233.28 68.39 233.28 68.05 223.01 68.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "58.32 19.92 66.88 20.03 75.67 20.11 92.75 20.2 92.74 30.43 84.48 30.47 75.73 30.59 58.03 30.86 75.54 31.18 84.37 31.3 93.24 31.36 93.7 31.36 93.7 30.9 93.71 19.71 93.71 19.21 93.21 19.21 75.63 19.27 66.84 19.34 58.05 19.44 57.81 19.44 57.81 19.67 58.03 30.86 58.32 19.92"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 44.56,
    y: 228.54,
    width: 35.16,
    height: 11.19
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "95.85 212.78 87.06 212.67 78.27 212.6 60.69 212.54 60.19 212.54 60.19 213.04 60.2 224.23 60.2 224.69 60.66 224.69 69.53 224.64 78.36 224.51 95.87 224.2 78.17 223.92 69.42 223.8 61.16 223.76 61.15 213.53 78.23 213.45 87.02 213.36 95.58 213.25 95.87 224.2 96.09 213.01 96.09 212.78 95.85 212.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "22.48 139.69 22.48 140.15 22.94 140.15 31.81 140.09 40.64 139.96 58.15 139.65 40.45 139.37 31.7 139.26 23.44 139.22 23.43 128.99 40.51 128.9 49.3 128.82 57.85 128.7 58.15 139.65 58.37 128.46 58.37 128.23 58.13 128.23 49.34 128.13 40.55 128.05 22.97 128 22.47 128 22.47 128.5 22.48 139.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "268.97 82.79 277.83 82.85 278.29 82.85 278.29 82.39 278.3 71.2 278.3 70.7 277.79 70.7 260.22 70.75 251.43 70.83 242.64 70.93 242.39 70.93 242.39 71.16 242.62 82.35 242.85 71.45 251.42 71.57 260.21 71.65 277.28 71.73 277.32 81.97 269.06 81.96 260.32 82.07 242.62 82.35 260.13 82.66 268.97 82.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m43.3,470.64c0,1.29.72,2.2,2.17,2.57v-5.08c-.14.03-.28.06-.4.1-1.17.35-1.77,1.21-1.77,2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m43.3,388.56c0,1.29.72,2.2,2.17,2.57v-5.08c-.14.03-.28.06-.4.1-1.17.35-1.77,1.21-1.77,2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m61.08,337.85h-17.02c-.84,0-1.73,0-2.65,0h-11.67c-.48,0-.96,0-1.46,0h-4.38v191.42h39.38v-191.42h-2.21Zm-25.75,22.35h8.03l4.59.24v4.97l-4.59.22h-8.03v-5.43Zm3.91,7.61h4.38c-.22,2.88,1.21,4.16,3.08,4.17h8.11v5.75h-15.31v-5.75h1.75c-1.34-.83-2.02-2.34-2.02-4.17Zm-6.48,34.63c.01-1.99,1.25-3.28,2.78-3.28s2.8,1.29,2.8,3.28-1.25,3.33-2.8,3.33-2.78-1.31-2.78-3.33Zm1.8,16.26h6.86c-1.39-.72-2.17-2.39-2.17-4.22,0-2.45.78-4.15,2.27-5.12,1-.7,2.32-1.04,3.95-1.04h9.35v5.76h-8.77c-1.7,0-2.5.75-2.5,2.2s1.14,2.42,2.62,2.42h8.66v5.75h-20.26v-5.75Zm4.95-13.36v-5.76h15.31v5.76h-15.31Zm6.62,38.97h8.68v5.76h-8.77c-1.71,0-2.5.67-2.5,1.92s1.04,2.07,2.59,2.07h8.68v5.75h-15.31v-5.75h1.85c-1.32-.7-2.12-2.14-2.12-3.91,0-2.62.97-4.34,2.8-5.19-1.67-.7-2.8-2.07-2.8-4.49s.75-3.95,2.17-4.88c1.02-.68,2.37-1.02,4.04-1.02h9.37v5.76h-8.77c-.77,0-1.35.12-1.75.38-.5.32-.75.83-.75,1.54,0,1.13,1.11,2.06,2.59,2.06Zm-10.12,46.18v-5.39h3.49v-4.04h4.48v4.04h4.45c1.39,0,1.98-.47,1.98-1.53v-2.5h4.4s0,5.15,0,5.15c0,3.15-1.77,4.65-4.87,4.65h-5.96v2.55h-4.48v-1.39c0-.83-.46-.99-1.28-1.16l-2.21-.38Zm13.89,19.92v-5.57c.95.13,1.61-.83,1.61-2.21s-.54-2.12-1.31-1.99c-.86.12-1.18,2.12-1.77,4.79-.7,3.12-2.1,4.88-4.68,4.9-3.05,0-4.55-3.03-4.51-7.63,0-4.22,1.56-7.63,4.93-7.51v5.58c-.95-.04-1.5.68-1.5,1.82,0,1.22.45,1.95,1.1,1.89.78-.07,1.24-1.11,1.54-2.98.79-4.81,1.81-6.78,4.66-6.76,3.34,0,5.11,3.3,5.08,8-.01,4.72-1.53,7.79-5.16,7.67Zm-2.74-31.25c-5.23,0-7.92-3.38-7.92-8.53,0-3.79,1.64-6.44,4.3-7.65,1.32-.61,2.91-.86,4.65-.75v11.1c1.75-.26,2.66-1.29,2.66-2.69,0-1.14-.51-2.13-1.84-2.44v-5.72c4.05.56,6.07,3.9,6.07,8.16,0,5.13-2.69,8.52-7.92,8.52Zm0-82.08c-5.23,0-7.92-3.38-7.92-8.53,0-3.79,1.64-6.44,4.3-7.65,1.32-.61,2.91-.86,4.65-.75v11.1c1.75-.26,2.66-1.29,2.66-2.69,0-1.14-.51-2.13-1.84-2.44v-5.72c4.05.56,6.07,3.9,6.07,8.16,0,5.13-2.69,8.52-7.92,8.52Zm5.23-31.39c-1.53,0-2.77-1.25-2.77-2.8s1.25-2.77,2.77-2.77,2.8,1.25,2.8,2.77-1.25,2.8-2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m85.18,342.35l-.29-.06c-.17-.04-.39-.08-.63-.13l-.47-.1c-.07-.01-.14-.03-.22-.04l-.28-.06c-.51-.11-1.12-.23-1.83-.38l-.64-.13c-.59-.12-1.24-.25-1.95-.4l-1.77-.36c-.29-.06-.59-.12-.9-.18l-.92-.19c-.27-.06-.54-.11-.82-.17l-1.67-.34c-.21-.04-.44-.09-.66-.13l-.75-.15c-.71-.15-1.45-.3-2.22-.46l-.88-.18c-.96-.2-1.96-.4-3.02-.62l-1.99-.41v191.42h22.3v-186.84h-.05c-.06-.02-.18-.05-.36-.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "85.59 342.44 85.59 342.12 85.41 342.09 85.59 342.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m23.41,338.15c-.24.14-.53.31-.84.49l-1.56.91s-.04.03-.07.04l-3.39,1.98c-.18.11-.36.21-.54.32l-1.18.69c-.08.05-.15.09-.23.14l-1.28.75c-.07.04-.14.08-.2.12l-.91.53c-.16.09-.31.18-.45.26l-.65.38c-.16.09-.3.17-.41.24l-.3.17s-.05.03-.05.03v184.07h12.57v-191.42l-.5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m17.02,341.89c-.4.23-.8.47-1.18.69l1.18-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m20.95,339.59c-1.04.61-2.22,1.3-3.39,1.98l3.39-1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m22.57,338.64c-.46.27-.99.58-1.56.91l1.56-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m15.6,342.72c-.45.26-.87.51-1.28.75l1.28-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m16.44,340.34c1.71.88,4.39-2.49,4.39-2.49,0,0,2.85-1.78,3.08,0l16.94-45.82c-1.3-.32-2.09-.6-2.09-.6l-27.43,53.77s3.39-5.74,5.1-4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m11.7,345c-.14.08-.24.14-.3.17l.3-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m23.41,338.15l.5-.29c-.14.08-.31.18-.5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m14.12,343.58c-.32.19-.63.37-.91.53l.91-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m12.76,344.38c-.24.14-.46.27-.65.38l.65-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m50.32,274.99s.09.18.25.47l-.25-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m55.1,284.13c.21.39.42.8.63,1.21l-.63-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m57.58,288.88c.26.5.52,1,.78,1.5-1.41.91-2.92,1.53-4.47,1.94l9.38,45.48s.01.05.01.05c2.37-.71,9.61,1.19,13.52,1.19s8.78,3.4,8.78,3.4l-.18-.35-27.82-53.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m56.14,286.12c.46.88.94,1.79,1.42,2.72l-1.42-2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m52.27,278.72c.59,1.13,1.3,2.48,2.08,3.97l-2.08-3.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m80.83,341.46l.64.13c-.2-.04-.42-.09-.64-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m85.59,342.44s-.02,0-.05-.01h.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m72.8,339.81l1.67.34c-.54-.11-1.09-.22-1.67-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m83.3,341.97l.28.06c-.09-.02-.18-.04-.28-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m77.11,340.7l1.77.36c-.55-.11-1.14-.23-1.77-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m84.89,342.3l.29.06c-.08-.02-.18-.04-.29-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m68.29,338.88l.88.18c-.29-.06-.59-.12-.88-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m83.79,342.07l.47.1c-.14-.03-.3-.06-.47-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m63.29,337.85l1.99.41c-.65-.13-1.3-.27-1.99-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m75.29,340.32l.92.19c-.3-.06-.6-.12-.92-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m71.4,339.52l.75.15c-.25-.05-.49-.1-.75-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m40.86,292.04l-16.94,45.82c1.42-2.61,7.47-1.66,12.81-.79s6.29-.75,16.13-2.06c9.19-1.22,10.32,2.32,10.43,2.79l-9.38-45.48c-4.97,1.31-10.22.42-13.04-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m32.67,337.85c-.94,0-1.92,0-2.92,0h2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m11.7,345c.11-.07.25-.15.41-.24.19-.11.41-.24.65-.38.14-.08.29-.17.45-.26.28-.16.59-.34.91-.53.07-.04.13-.08.2-.12.4-.24.83-.49,1.28-.75.08-.05.15-.09.23-.14.39-.23.78-.46,1.18-.69.18-.11.36-.21.54-.32,1.17-.68,2.35-1.37,3.39-1.98.02-.01.04-.03.07-.04.57-.33,1.1-.64,1.56-.91.31-.18.6-.35.84-.49.19-.11.36-.21.5-.29-.24-1.78-3.08,0-3.08,0,0,0-2.68,3.37-4.39,2.49-1.71-.88-5.1,4.86-5.1,4.86,0,0,.02-.01.05-.03.06-.03.16-.09.3-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m52.85,335.01c-9.84,1.3-10.79,2.93-16.13,2.06s-11.39-1.82-12.81.79h5.83c1,0,1.98,0,2.92,0h8.75c.92,0,1.8,0,2.65,0h19.23s0-.02-.01-.05c-.11-.47-1.23-4.01-10.43-2.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m76.81,339.04c-3.91,0-11.15-1.9-13.52-1.19.68.14,1.34.28,1.99.41,1.05.22,2.06.42,3.02.62.3.06.59.12.88.18.77.16,1.51.31,2.22.46.25.05.5.1.75.15.22.05.44.09.66.13.58.12,1.14.23,1.67.34.28.06.55.11.82.17.31.06.62.13.92.19.31.06.61.12.9.18.63.13,1.22.25,1.77.36.71.15,1.36.28,1.95.4.22.05.43.09.64.13.71.15,1.32.27,1.83.38.1.02.19.04.28.06.07.02.15.03.22.04.17.03.32.07.47.1.25.05.46.09.63.13.11.02.2.04.29.06.18.04.3.06.36.07.03,0,.05.01.05.01,0,0-4.86-3.4-8.78-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m53.9,292.32c1.55-.41,3.06-1.03,4.47-1.94-.26-.5-.53-1.01-.78-1.5,0-.01-.01-.02-.02-.03-.49-.93-.96-1.84-1.42-2.72-.14-.27-.28-.53-.41-.79-.21-.41-.42-.81-.63-1.21-.26-.49-.51-.97-.75-1.43-.78-1.49-1.48-2.84-2.08-3.97-.8-1.53-1.39-2.66-1.7-3.26-.16-.3-.25-.47-.25-.47h-3.16l-8.39,16.44h0s.79.28,2.09.6c2.82.7,8.07,1.59,13.04.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "294.73 375.67 320.71 375.67 320.74 333.17 294.73 333.17 294.73 375.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m109.35,329.17h176.52v-174.33H109.35v174.33Zm125.14-129.5v117h-77v-117h77Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 109.35,
    y: 333.17,
    width: 176.52,
    height: 42.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "294.73 329.17 320.74 329.17 320.87 154.84 294.73 154.84 294.73 329.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 109.35,
    y: 375.67,
    width: 176.52,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 294.73,
    y: 375.67,
    width: 25.98,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 157.49,
    y: 199.67,
    width: 77,
    height: 117
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 294.73,
    y: 148.17,
    width: 26.15,
    height: 6.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 109.35,
    y: 148.17,
    width: 176.52,
    height: 6.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 109.35,
    y: 329.17,
    width: 176.52,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 294.73,
    y: 329.17,
    width: 26.02,
    height: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "109.35 333.17 109.35 329.17 109.35 154.84 109.35 148.17 100.49 148.17 100.49 154.84 100.49 529.17 109.35 529.17 109.35 383.67 109.35 375.67 109.35 333.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "294.73 333.17 294.73 329.17 294.73 154.84 294.73 148.17 285.87 148.17 285.87 154.84 285.87 329.17 285.87 333.17 285.87 375.67 285.87 383.67 285.87 529.17 294.73 529.17 294.73 383.67 294.73 375.67 294.73 333.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m49.98,494.75c-2.85-.01-3.87,1.95-4.66,6.76-.31,1.87-.77,2.91-1.54,2.98-.65.06-1.1-.67-1.1-1.89,0-1.14.56-1.87,1.5-1.82v-5.58c-3.37-.11-4.93,3.3-4.93,7.51-.04,4.59,1.46,7.63,4.51,7.63,2.57-.01,3.98-1.78,4.68-4.9.58-2.67.9-4.66,1.77-4.79.77-.13,1.31.67,1.31,1.99s-.67,2.34-1.61,2.21v5.57c3.63.13,5.15-2.95,5.16-7.67.03-4.7-1.74-8-5.08-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m39.5,492.03v1.39h4.48v-2.55h5.96c3.1,0,4.87-1.5,4.87-4.65v-5.16h-4.4v2.52c0,1.06-.58,1.53-1.98,1.53h-4.45v-4.04h-4.48v4.04h-3.49v5.39l2.21.38c.82.17,1.28.32,1.28,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m49.01,462.5v5.72c1.32.31,1.84,1.29,1.84,2.44,0,1.39-.9,2.42-2.66,2.69v-11.1c-1.74-.11-3.33.14-4.65.75-2.66,1.21-4.3,3.87-4.3,7.65,0,5.15,2.69,8.53,7.92,8.53s7.92-3.38,7.92-8.52c0-4.26-2.02-7.6-6.07-8.16Zm-3.53,10.72c-1.45-.38-2.17-1.28-2.17-2.57,0-1.2.6-2.06,1.77-2.41.12-.04.26-.07.4-.1v5.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m44.29,440.71c.4-.25.99-.38,1.75-.38h8.77v-5.76h-9.37c-1.67,0-3.02.33-4.04,1.02-1.42.93-2.17,2.55-2.17,4.88s1.13,3.8,2.8,4.49c-1.82.85-2.8,2.57-2.8,5.19,0,1.77.79,3.21,2.12,3.91h-1.85v5.75h15.31v-5.75h-8.68c-1.54,0-2.59-.88-2.59-2.07s.79-1.92,2.5-1.92h8.77v-5.76h-8.68c-1.48,0-2.59-.93-2.59-2.06,0-.71.25-1.22.75-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m54.81,418.71h-8.66c-1.48,0-2.62-1-2.62-2.42s.81-2.2,2.5-2.2h8.77v-5.76h-9.35c-1.63,0-2.95.35-3.95,1.04-1.49.97-2.27,2.67-2.27,5.12,0,1.82.78,3.49,2.17,4.22h-6.86v5.75h20.26v-5.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 39.5,
    y: 399.58,
    width: 15.31,
    height: 5.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m38.34,402.45c0-1.99-1.25-3.28-2.8-3.28s-2.77,1.29-2.78,3.28c0,2.02,1.25,3.33,2.78,3.33s2.8-1.31,2.8-3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m49.01,380.42v5.72c1.32.31,1.84,1.29,1.84,2.44,0,1.39-.9,2.42-2.66,2.69v-11.1c-1.74-.11-3.33.14-4.65.75-2.66,1.21-4.3,3.87-4.3,7.65,0,5.15,2.69,8.53,7.92,8.53s7.92-3.38,7.92-8.52c0-4.26-2.02-7.6-6.07-8.16Zm-3.53,10.72c-1.45-.38-2.17-1.28-2.17-2.57,0-1.2.6-2.06,1.77-2.41.12-.04.26-.07.4-.1v5.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m39.5,377.74h15.31v-5.75h-8.11c-1.86-.01-3.3-1.29-3.08-4.17h-4.38c0,1.84.68,3.34,2.02,4.17h-1.75v5.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "47.95 365.41 47.95 360.44 43.36 360.21 35.33 360.21 35.33 365.63 43.36 365.63 47.95 365.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m52.39,360.14c-1.52,0-2.77,1.25-2.77,2.77s1.24,2.8,2.77,2.8,2.8-1.25,2.8-2.8-1.25-2.77-2.8-2.77Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "233.28 98.81 234.48 98.81 234.48 68.41 233.28 68.39 233.28 98.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "233.28 98.81 234.48 98.81 234.48 68.41 233.28 68.39 233.28 98.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "234.48 68.03 234.48 57.4 233.28 57.39 233.28 68.05 234.48 68.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "234.48 68.03 234.48 57.4 233.28 57.39 233.28 68.05 234.48 68.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "234.48 56.66 234.48 .17 233.28 .17 233.28 56.67 234.48 56.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "234.48 56.66 234.48 .17 233.28 .17 233.28 56.67 234.48 56.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "233.28 57.39 234.48 57.4 234.48 56.66 233.28 56.67 233.28 57.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "233.28 57.39 234.48 57.4 234.48 56.66 233.28 56.67 233.28 57.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "233.28 68.05 233.28 68.39 234.48 68.41 234.48 68.03 233.28 68.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "233.28 68.05 233.28 68.39 234.48 68.41 234.48 68.03 233.28 68.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "230.54 98.81 230.54 100.31 237.21 100.31 237.21 98.81 234.48 98.81 233.28 98.81 230.54 98.81"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 230.54,
    y: 100.31,
    width: 6.67,
    height: 2.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m233.85,138.28c2.83,0,5.11-2.29,5.13-5.11h-10.27c.02,2.83,2.32,5.12,5.15,5.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "230.54 102.52 228.16 102.52 223.22 122.44 217.17 133.17 228.7 133.17 238.98 133.17 250.6 133.17 244.54 122.44 239.6 102.52 237.21 102.52 230.54 102.52"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 171.12,
    y: 0.13,
    width: 1.2,
    height: 88.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 171.12,
    y: 0.13,
    width: 1.2,
    height: 88.13
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "168.38 88.26 168.38 89.76 175.05 89.76 175.05 88.26 172.32 88.26 171.12 88.26 168.38 88.26"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 168.38,
    y: 89.76,
    width: 6.67,
    height: 2.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m166.58,122.64c0,2.84,2.31,5.14,5.15,5.13s5.14-2.31,5.13-5.15h-10.28s0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "168.38 91.97 166 91.97 161.06 111.89 155.01 122.62 166.58 122.62 176.86 122.62 188.44 122.62 182.38 111.89 177.44 91.97 175.05 91.97 168.38 91.97"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 111.49,
    y: 0.08,
    width: 1.2,
    height: 77.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 111.49,
    y: 0.08,
    width: 1.2,
    height: 77.15
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "108.76 77.24 108.76 78.74 115.43 78.74 115.43 77.24 112.69 77.24 111.49 77.24 108.76 77.24"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 108.76,
    y: 78.74,
    width: 6.67,
    height: 2.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m112.09,116.74c2.84,0,5.14-2.3,5.14-5.14h-10.28c0,2.84,2.3,5.14,5.14,5.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "108.76 80.95 106.38 80.95 101.44 100.87 95.38 111.6 106.95 111.6 117.23 111.6 128.81 111.6 122.76 100.87 117.82 80.95 115.43 80.95 108.76 80.95"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStembureauInside);
export default __webpack_public_path__ + "static/media/stembureau-inside.aeec3ab527c4582ebfd47ac08af63d70.svg";
export { ForwardRef as ReactComponent };